import React, { useEffect, useState } from 'react';
import ModalAddIssue from './ModalAddIssue';

function IssueBubble({ name, properties, existingIssues, onItemAdd, onItemRemove }) {
  const [itemSelected, setItemSelected] = useState(false);
  const [issues, setIssues] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (existingIssues && existingIssues.length > 0) {
      setItemSelected(true);
      setIssues(existingIssues);
    }
  }, [existingIssues]);

  const handleAddIssue = (issue) => {
    if (!issue/* || !issue.description*/) return;
    setIssues((prevIssues) => [...prevIssues, issue]);
    onItemAdd && onItemAdd(issue);
  };

  const handleRemoveIssue = (issue) => {
    setIssues((prevIssues) => {
      const updatedIssues = prevIssues.filter((i) => i._id !== issue._id);
      onItemRemove && onItemRemove(issue);
      return updatedIssues;
    });
  };

  return (
    <>
      <div className="item-bubble" style={{ display: "block", maxWidth: 'none', marginBottom: '12px' }}>
        <label>
          <input 
            type="checkbox"
            checked={itemSelected}
            onChange={() => setItemSelected(!itemSelected)}
          /> {name}
        </label>
        {itemSelected && (
          <>
            <ul className="item-list">
              {issues.map((item, index) => (
                <li key={index}><div className="color-item" style={{ backgroundColor: item.color }} /> {item.description} <i style={{ float: 'right' }} className='icon-remove' onClick={() => handleRemoveIssue(item)}></i></li>
              ))}
            </ul>
            <button style={{ margin: '15px' }} className="action-link" onClick={() => setIsModalOpen(true)}>+ Add {name} details</button>
          </>
        )}
      </div>
      {itemSelected && <ModalAddIssue name={name} properties={properties} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onDone={handleAddIssue} />}
    </>
  );
}

export default IssueBubble;